<script setup>
import { computed } from 'vue'

const props = defineProps({
    name: {
        type: String,
        required: true,
    },
    // FDS Web icon grid: 24 = base UI, 20 = dense rows, 16 = inline, 32 = transport/hero.
    size: {
        type: Number,
        default: 24,
        validator: value => [16, 20, 24, 32].includes(value),
    },
    // The Fill=filled twin — on/selected states only.
    filled: {
        type: Boolean,
        default: false,
    },
    // Accessible name; without it the icon is decorative.
    label: {
        type: String,
        default: '',
    },
})

const href = computed(() => `#icon-${props.name}${props.filled ? '-filled' : ''}`)
</script>

<template>
    <svg
        class="icon"
        :class="`icon-${size}`"
        :width="size"
        :height="size"
        :role="label ? 'img' : undefined"
        :aria-hidden="label ? undefined : 'true'"
    >
        <title v-if="label">{{ label }}</title>
        <use :href="href" />
    </svg>
</template>

<style lang="scss" scoped>
// Strokes are 1.5px on the 16/20/24 grids and 2px at 32; glyph colour rides
// currentColor. :where() keeps consumers' `.icon` overrides winning.
:where(.icon) {
    display: inline-block;
    flex-shrink: 0;
    vertical-align: middle;
    stroke-width: 1.5;
}

:where(.icon-32) {
    stroke-width: 2;
}
</style>
